import React from 'react';
import InputMask from 'react-input-mask';
import { InputWrapper, Label, FieldContainer, FloatingLabel, MaskedInputStyle, ErrorMessage } from './styles';

export default function DateInput({ label, name, value, onChange, onBlur, error, placeholder, disabled, standalone }) {
  const fieldLabel = placeholder || 'Data de nascimento';
  const hasValue = !!value && value.replace(/[_/]/g, '').length > 0;

  return (
    <InputWrapper $standalone={standalone}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <FieldContainer $hasError={!!error} $disabled={disabled}>
        {hasValue && <FloatingLabel>{fieldLabel}</FloatingLabel>}
        <MaskedInputStyle $hasValue={hasValue}>
          <InputMask
            mask="99/99/9999"
            maskChar={null}
            name={name}
            id={name}
            value={value}
            inputMode="numeric"
            onChange={onChange}
            onBlur={onBlur}
            placeholder={hasValue ? '' : fieldLabel}
            disabled={disabled}
            autoComplete="off"
          />
        </MaskedInputStyle>
      </FieldContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
}
